<div name="driver-events" attr.data-env="{{env}} | {{build}}">
    <jr-note [type]="NoteType.Info" *ngIf="isTooEarlyToAcceptDriverEvents" class="d-block mb-3">
        Trip events for this booking will be available closer to travel time.
    </jr-note>

    <jr-note [type]="NoteType.Info" *ngIf="isTooLateToAcceptDriverEvents" class="d-block mb-3">
        Trip events are no longer available for this booking.
    </jr-note>
    
    <jr-note *ngIf="isGeolocationError" [type]="NoteType.Warn" class="d-block mb-3">
        Geolocation is not supported on your device or you didn't allow it.
    </jr-note>
    
    <jr-note *ngIf="isTrackEventError" [type]="NoteType.Warn" class="d-block mb-3">
        There was an error tracking driver event. Please try again.
    </jr-note>

    <div class="mb-3" *ngFor="let item of sequenceEvents">
        <jr-note *ngIf="item.occurredAt else eventBtn" [type]="NoteType.Success">
            {{getNotificationLabel(item.type)}} - {{item.occurredAt | date: eventTimeFormat}}
        </jr-note>
        <ng-template #eventBtn>
            <button [disabled]="isEventDisabled(item)" 
                (click)="triggerEvent(item)"
                class="d-block w-100 btn btn-primary">
                {{item.label}}
            </button>
        </ng-template>
    </div>
    <hr>
    <div>
        <jr-note *ngIf="noShowEvent?.occurredAt; else noShowEventBtn" [type]="NoteType.Error">
            {{getNotificationLabel(noShowEvent.type)}} - {{noShowEvent.occurredAt | date: eventTimeFormat}}
        </jr-note>
        <ng-template #noShowEventBtn>
            <button [disabled]="isEventDisabled(noShowEvent)"
                (click)="openEventConfirmationModal(noShowEvent)"
                class="d-block w-100 mt-3 btn btn-destructive">
                {{noShowEvent.label}}
            </button>
        </ng-template>
    </div>
</div>
